export const CONFIGURATION_FIELDS = {
  merchants: ['merchantId', 'enabled', 'callbackUrl', 'callbackSecretRef', 'callbackAllowedHosts', 'callbackVersion', 'maxActiveOrders', 'apiKeyRef', 'allowDepositFallback', 'settlementMode', 'telegramUsersEnabled', 'siteBalancesEnabled', 'receiptAllowedHosts'],
  processings: ['provider', 'name', 'enabled', 'baseUrl', 'allowedHosts', 'credentialRef', 'webhookSecretRef', 'callbackUrl'],
  routes: ['processingId', 'merchantIds', 'method', 'currency', 'scale', 'group', 'priority', 'position', 'minAmount', 'maxAmount', 'enabled', 'tariffId', 'providerOptions', 'legacyKey', 'legacyMethod', 'processingCommissionBps'],
  tariffs: ['name', 'currency', 'scale', 'markupBps', 'fixedUnits', 'adjustmentUnits', 'providerFeeBps', 'providerFixedUnits', 'rounding', 'enabled', 'legacyMultiplier', 'roundingIncrementUnits', 'creditIncrementUnits', 'adjustmentMinUnits', 'adjustmentMaxUnits'],
};

export const LABELS = {
  processingCommissionBps: 'Комиссия процессинга для учёта долга, %',
  name: 'Название', provider: 'Провайдер', baseUrl: 'Базовый URL', allowedHosts: 'Разрешённые хосты провайдера',
  credentialRef: 'Ссылка на учётные данные', webhookSecretRef: 'Ссылка на секрет вебхука', callbackUrl: 'URL обратного вызова',
  merchantId: 'ID мерчанта', callbackVersion: 'Версия обратного вызова', settlementMode: 'Режим расчётов',
  callbackSecretRef: 'Ссылка на секрет обратного вызова', apiKeyRef: 'Ссылка на API-ключ', callbackAllowedHosts: 'Хосты обратного вызова',
  telegramUsersEnabled: 'Доступ к Telegram-пользователям V4 и списаниям',
  siteBalancesEnabled: 'Балансы клиентов сайта по логину',
  receiptAllowedHosts: 'Хосты чеков', maxActiveOrders: 'Максимум активных заказов', allowDepositFallback: 'Разрешить резервный депозит',
  processingId: 'Процессинг', tariffId: 'Тариф', merchantIds: 'Мерчанты маршрута', method: 'Метод оплаты', currency: 'Валюта', scale: 'Знаков после запятой',
  group: 'Группа', priority: 'Приоритет', position: 'Позиция', minAmount: 'Минимальная сумма', maxAmount: 'Максимальная сумма',
  legacyKey: 'Ключ legacy', legacyMethod: 'Метод legacy', providerOptions: 'Параметры провайдера (JSON)',
  markupBps: 'Наценка, %', fixedUnits: 'Фиксированная наценка', adjustmentUnits: 'Корректировка суммы',
  providerFeeBps: 'Комиссия провайдера, %', providerFixedUnits: 'Фиксированная комиссия провайдера', rounding: 'Округление',
  legacyMultiplier: 'Множитель legacy', roundingIncrementUnits: 'Шаг округления', creditIncrementUnits: 'Шаг зачисления',
  adjustmentMinUnits: 'Минимальная корректировка', adjustmentMaxUnits: 'Максимальная корректировка',
};

const toBigInt = window.BigInt;
const MONEY_FIELDS = ['fixedUnits', 'adjustmentUnits', 'providerFixedUnits', 'roundingIncrementUnits', 'creditIncrementUnits', 'adjustmentMinUnits', 'adjustmentMaxUnits'];
const HOST_FIELDS = ['allowedHosts', 'callbackAllowedHosts', 'receiptAllowedHosts'];
const REF_FIELDS = ['credentialRef', 'webhookSecretRef', 'callbackSecretRef', 'apiKeyRef'];
export const DEFAULTS = {
  merchants: { enabled: false, merchantId: '', callbackVersion: 'v4', callbackAllowedHosts: [], maxActiveOrders: 1, settlementMode: 'v4', telegramUsersEnabled: false, siteBalancesEnabled: false, allowDepositFallback: false, receiptAllowedHosts: [] },
  processings: { enabled: false, name: '', provider: '', baseUrl: '', allowedHosts: [], credentialRef: '' },
  routes: { enabled: false, processingId: '', tariffId: '', merchantIds: [], method: '', currency: '', priority: 0, position: 0, group: null, scale: 2, minAmount: '0.01', providerOptions: {} },
  tariffs: { enabled: false, name: '', currency: 'RUB', scale: 2, markupBps: 0, providerFeeBps: 0, fixedUnits: '0', adjustmentUnits: '0', providerFixedUnits: '0', rounding: 'half_up' },
};

export function boundedInteger(value, min, max) {
  if (!/^\d+$/.test(String(value))) throw new Error(`Введите целое число от ${min} до ${max}`);
  const number = Number(value);
  if (!Number.isSafeInteger(number) || number < min || number > max) throw new Error(`Введите целое число от ${min} до ${max}`);
  return number;
}

export function moneyToUnits(value, scale) {
  const precision = boundedInteger(scale, 0, 8);
  const normalized = String(value).trim().replace(',', '.');
  if (normalized.length > 43 || !/^(0|[1-9]\d*)(\.\d+)?$/.test(normalized)) throw new Error('Введите неотрицательную сумму без экспоненты');
  const [whole, fraction = ''] = normalized.split('.');
  if (fraction.length > precision) throw new Error(`Допустимо не более ${precision} знаков после запятой`);
  const units = (whole + fraction.padEnd(precision, '0')).replace(/^0+(?=\d)/, '');
  if (units.length > 34) throw new Error('Сумма слишком велика');
  return units;
}

export function unitsToMoney(units, scale) {
  const precision = boundedInteger(scale, 0, 8);
  const value = String(units);
  if (!/^(0|[1-9]\d*)$/.test(value) || value.length > 34) throw new Error('Некорректная сумма в минимальных единицах');
  if (!precision) return value;
  const padded = value.padStart(precision + 1, '0');
  return `${padded.slice(0, -precision)}.${padded.slice(-precision)}`;
}

export function percentToBps(value) {
  const units = moneyToUnits(value, 2);
  return boundedInteger(units, 0, 1000000);
}

export function validateSecretReference(value, required = false) {
  if (value == null || value === '') {
    if (required) throw new Error('Укажите имя переменной V4_, а не значение секрета');
    return undefined;
  }
  if (!/^V4_[A-Z][A-Z0-9_]{2,100}$/.test(value)) throw new Error('Ожидается имя V4_XXX: заглавные буквы, цифры и подчёркивания. Не вводите секрет');
  return value;
}

export function parseProviderOptions(value) {
  let result;
  try { result = JSON.parse(value || '{}'); } catch { throw new Error('Некорректный JSON параметров провайдера'); }
  if (!result || Array.isArray(result) || typeof result !== 'object') throw new Error('Параметры должны быть JSON-объектом');
  const inspect = (item, depth = 0) => {
    if (depth > 20) throw new Error('Слишком глубокая вложенность параметров');
    if (!item || typeof item !== 'object') return;
    Object.entries(item).forEach(([key, child]) => {
      if (depth === 0 && key === 'videoBotTokenRef') {
        validateSecretReference(child, true);
        if (['V4_RECEIPT_STORAGE_KEY', 'V4_RECEIPT_LINK_KEY'].includes(child)) throw new Error('Выберите ссылку на токен бота, а не ключ документов');
        return;
      }
      if (key.includes('$') || key.includes('.') || /^(?:__proto__|prototype|constructor)$/i.test(key) || /secret|password|token|credential|api[_-]?key|authorization|private[_-]?key/i.test(key)) {
        throw new Error('Запрещены служебные ключи, ссылки на прототип и секреты');
      }
      inspect(child, depth + 1);
    });
  };
  inspect(result);
  return result;
}

function parseHosts(value, required) {
  const values = String(value || '').split(/[,\n]/).map(item => item.trim().toLowerCase()).filter(Boolean);
  const hosts = [...new Set(values)];
  if ((required && !hosts.length) || hosts.length > 20 || hosts.some(host => host.length > 253 || !/^(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,63}$/.test(host))) {
    throw new Error('Укажите до 20 доменных имён без протокола и пути, через запятую или новую строку');
  }
  return hosts;
}

function validateUrl(value, allowedHosts) {
  let url;
  try { url = new URL(value); } catch { throw new Error('Введите публичный HTTPS URL'); }
  const host = url.hostname.toLowerCase();
  if (value.length > 2048 || /[?#\\\s]/.test(value) || url.protocol !== 'https:' || url.username || url.password || (url.port && url.port !== '443') || !host.includes('.') || host.endsWith('.') || /^\d+\.\d+\.\d+\.\d+$/.test(host) || host.includes(':') || /(^|\.)(localhost|local|internal|localdomain)$/.test(host)) throw new Error('Нужен публичный HTTPS URL без порта, параметров и авторизации');
  if (allowedHosts && !allowedHosts.includes(host)) throw new Error('Домен URL должен входить в список разрешённых хостов');
  return value;
}

export function createForm(kind, original) {
  const source = { ...DEFAULTS[kind], ...original };
  return Object.fromEntries(CONFIGURATION_FIELDS[kind].map(key => {
    let value = source[key];
    if (HOST_FIELDS.includes(key)) value = (value || []).join(', ');
    else if (kind === 'tariffs' && MONEY_FIELDS.includes(key) && value !== undefined) value = unitsToMoney(value, source.scale);
    else if (kind === 'tariffs' && ['markupBps', 'providerFeeBps'].includes(key)) value = unitsToMoney(String(value), 2);
    else if (key === 'processingCommissionBps' && value != null) value = unitsToMoney(String(value), 2);
    else if (key === 'providerOptions') value = JSON.stringify(value || {}, null, 2);
    else if (['telegramUsersEnabled', 'siteBalancesEnabled'].includes(key)) value = value === true;
    else if (value == null) value = '';
    else if (typeof value === 'number') value = String(value);
    return [key, value];
  }));
}

export function buildConfiguration(kind, form, original = null) {
  const data = {};
  const errors = {};
  const check = (key, fn) => {
    try { const value = fn(); if (value !== undefined) data[key] = value; }
    catch (error) { errors[key] = error.message; }
  };
  const requiredText = (key, max = 128) => check(key, () => {
    const value = String(form[key] || '').trim();
    if (!value || value.length > max) throw new Error(`Обязательное поле, не более ${max} символов`);
    return value;
  });
  const integer = (key, min, max) => check(key, () => boundedInteger(form[key], min, max));
  data.enabled = original ? original.enabled : false;
  if (['processings', 'tariffs'].includes(kind)) requiredText('name', 120);
  if (['merchants', 'processings'].includes(kind)) {
    HOST_FIELDS.filter(key => CONFIGURATION_FIELDS[kind].includes(key)).forEach(key => check(key, () => parseHosts(form[key], key === 'allowedHosts')));
    REF_FIELDS.filter(key => CONFIGURATION_FIELDS[kind].includes(key)).forEach(key => check(key, () =>
      validateSecretReference(form[key], key === 'credentialRef' && !['btc', 'ltc'].includes(form.provider))));
    check('callbackUrl', () => form.callbackUrl ? validateUrl(form.callbackUrl, kind === 'merchants' ? data.callbackAllowedHosts : undefined) : (original?.callbackUrl != null ? null : undefined));
  }
  if (kind === 'merchants') {
    requiredText('merchantId');
    integer('maxActiveOrders', 1, 100);
    ['callbackVersion', 'settlementMode'].forEach(key => check(key, () => {
      const values = key === 'settlementMode' ? ['v4', 'legacy', 'telegram'] : ['v4', 'legacy'];
      if (!values.includes(form[key])) throw new Error(`Выберите ${values.join(', ')}`);
      return form[key];
    }));
    data.allowDepositFallback = Boolean(form.allowDepositFallback);
    data.siteBalancesEnabled = form.siteBalancesEnabled === true;
    check('telegramUsersEnabled', () => {
      const enabled = form.telegramUsersEnabled === true;
      if (enabled && data.settlementMode !== 'telegram') throw new Error('Доступ к Telegram-балансу V4 разрешён только в режиме telegram. Явно отключите доступ или выберите telegram.');
      return enabled;
    });
    if (data.callbackUrl) {
      const key = data.callbackVersion === 'legacy' ? 'apiKeyRef' : 'callbackSecretRef';
      check(key, () => validateSecretReference(form[key], true));
    }
  }
  if (kind === 'processings') {
    requiredText('provider', 32);
    check('baseUrl', () => validateUrl(form.baseUrl, data.allowedHosts));
  }
  if (['tariffs', 'routes'].includes(kind)) {
    check('currency', () => {
      if (!/^[A-Z][A-Z0-9]{2,11}$/.test(form.currency)) throw new Error('Код валюты: 3–12 заглавных букв или цифр');
      return form.currency;
    });
    integer('scale', 0, 8);
  }
  if (kind === 'tariffs') {
    ['markupBps', 'providerFeeBps'].forEach(key => check(key, () => percentToBps(form[key])));
    MONEY_FIELDS.forEach(key => check(key, () => {
      const optional = !['fixedUnits', 'adjustmentUnits', 'providerFixedUnits'].includes(key);
      if (optional && form[key] === '') {
        if (original?.[key] !== undefined) throw new Error('Для удаления этого параметра создайте новый тариф; пустое значение не удаляет сохранённое');
        return undefined;
      }
      const value = moneyToUnits(form[key], form.scale);
      if (['roundingIncrementUnits', 'creditIncrementUnits'].includes(key) && value === '0') throw new Error('Шаг должен быть больше нуля');
      return value;
    }));
    check('rounding', () => {
      if (!['half_up', 'up', 'down'].includes(form.rounding)) throw new Error('Выберите режим округления');
      return form.rounding;
    });
    check('legacyMultiplier', () => {
      if (!form.legacyMultiplier) {
        if (original?.legacyMultiplier !== undefined) throw new Error('Существующий множитель нельзя удалить пустым значением');
        return undefined;
      }
      if (moneyToUnits(form.legacyMultiplier, 8) === '0') throw new Error('Множитель должен быть больше нуля');
      return String(form.legacyMultiplier).trim().replace(',', '.');
    });
    if (data.adjustmentMinUnits !== undefined || data.adjustmentMaxUnits !== undefined) {
      if (data.adjustmentMinUnits === undefined || data.adjustmentMaxUnits === undefined) errors.adjustmentMinUnits = 'Заполните обе границы диапазона';
      else {
        const min = toBigInt(data.adjustmentMinUnits);
        const max = toBigInt(data.adjustmentMaxUnits);
        const step = toBigInt(data.roundingIncrementUnits || '1');
        if (min > max || max - min > toBigInt(1000000) * step || min % step !== toBigInt(0) || max % step !== toBigInt(0)) errors.adjustmentMinUnits = 'Границы должны быть кратны шагу; минимум ≤ максимум; диапазон ≤ 1 000 000 шагов';
      }
    }
  }
  if (kind === 'routes') {
    check('processingCommissionBps', () => {
      if (!String(form.processingCommissionBps ?? '').trim()) return original?.processingCommissionBps != null ? null : undefined;
      const value = percentToBps(form.processingCommissionBps);
      if (value > 10000) throw new Error('Комиссия должна быть от 0 до 100 %');
      return value;
    });
    ['processingId', 'tariffId'].forEach(key => requiredText(key));
    requiredText('method', 32);
    ['priority', 'position'].forEach(key => integer(key, 0, 1000000));
    check('merchantIds', () => {
      if (!Array.isArray(form.merchantIds) || !form.merchantIds.length || form.merchantIds.length > 1000 || form.merchantIds.some(id => typeof id !== 'string' || !id.trim() || id.length > 128)) throw new Error('Выберите от 1 до 1000 мерчантов');
      return form.merchantIds;
    });
    check('group', () => {
      const value = String(form.group || '').trim();
      if (!value) return null;
      if (value.length > 64) throw new Error('Не более 64 символов');
      return value;
    });
    check('minAmount', () => {
      if (moneyToUnits(form.minAmount, form.scale) === '0') throw new Error('Минимальная сумма должна быть больше нуля');
      return String(form.minAmount).trim().replace(',', '.');
    });
    check('maxAmount', () => {
      if (!form.maxAmount) return original?.maxAmount != null ? null : undefined;
      const maximum = moneyToUnits(form.maxAmount, form.scale);
      if (data.minAmount && toBigInt(maximum) < toBigInt(moneyToUnits(data.minAmount, form.scale))) throw new Error('Максимум не может быть меньше минимума');
      return String(form.maxAmount).trim().replace(',', '.');
    });
    ['legacyKey', 'legacyMethod'].forEach(key => {
      if (form[key]) requiredText(key, 64);
      else if (original?.[key] !== undefined) errors[key] = 'Сохранённое значение нельзя удалить пустой строкой';
    });
    check('providerOptions', () => parseProviderOptions(form.providerOptions));
  }
  if (Object.keys(errors).length) return { data: null, errors };
  if (!original) return { data, errors };
  const initial = createForm(kind, original);
  const patch = Object.fromEntries(Object.entries(data).filter(([key]) => key !== 'enabled' && (['telegramUsersEnabled', 'siteBalancesEnabled'].includes(key)
    ? (form[key] === true) !== (initial[key] === true)
    : JSON.stringify(form[key]) !== JSON.stringify(initial[key]))));
  if (kind === 'tariffs' && form.scale !== initial.scale) MONEY_FIELDS.forEach(key => { if (data[key] !== undefined) patch[key] = data[key]; });
  return { data: patch, errors };
}
